import React from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { routes } from '../../routes';
import { BASE_PATH } from '../../../lib/constants/routes';

const ClientEntry = () => {
    const router = createBrowserRouter(routes, {
        basename: BASE_PATH,
    });

    return <RouterProvider router={router} />;
};

export default ClientEntry;
